<template>
<div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body text-center mb-5">
              <img src="@/assets/images/co-worker.svg" alt="item_blank" class="mb-3">
              <h4 class="mb-3"><b>Bạn không có quyền truy cập tính năng này</b></h4>
              <b-button
                @click="$router.push(`/dashboard`)"
                variant="primary">Quay lại trang chủ
              </b-button>
            </div>
          </div>
        </div>
      </div>
</template>
<script>
export default {
  name: 'NotPermission'
};
</script>